<template>
  <div class="map_container">
    <template>
      <div class="map_container__map_content">
        <GmapMap
          v-if="!loadingMap"
          :center="center"
          :zoom="zoom"
          :options="mapOptions"
          @tilesloaded="showMap"
          style="width: 100%; height: 100%"
          ref="map"
          @zoom_changed="getZoom($event)"
          @click="windowClicked">
          <!-- Billboard Marker -->
          <gmap-info-window
            :options="infoWindowBillboard"
            :position="infoWindowBillboardPosition"
            :opened="infoWindowBillboardOpen"
            @closeclick="closeWindowBillboard()"
          ></gmap-info-window>
          <gmap-marker
            :key="m.id"
            v-for="m in markers"
            :position="m.position"
            :clickable="true"
            :icon="getIcon(m.record)"
            @click="toggleInfoWindowMarker(m, m.id)"
          ></gmap-marker>
        </GmapMap>
        <div v-else class="map_loading">
          <adx-loading />
        </div>
        <info-window 
          ref="window"
          :keyComp="componentWindowKey" 
          @updateData="updateData" 
          @toggleModal="toggleModal"
          @toggleModalEdit="toggleModalEdit"
          @reuseContent="reuseContent" 
          :isStaff="isStaff"
          :isSuperuser="isSuperuser" 
          :placements="placements"/>
      </div>
      <div v-if="toggleButton" class="map_container__toggle">
        <button @click.stop="toggleSideMenu()" class="buttonMenu">
          <div class="menuBar"></div>
          <div class="menuBar"></div>
          <div class="menuBar"></div>
        </button>
      </div>
      <div class="map_container__reload" @click="reload"><img src="img/icons/adx-ic-refresh.png"></div>
      <div @click.stop="windowClicked" class="map_container__map_nav">
        <div class="map_container__map_nav__content">
          <div v-if="toggleSide" class="map_container__map_nav__content__sidebar">
            <div class="map_container__map_nav__content__top">
              <div class="ic-burger-wrapper">
                <img class="ic-burger" :src="`/img/ic-burger.png`" alt="" @click.stop="toggleSideMenu()">
              </div>
              <div class="map_container__map_nav__content__top__title" @click.stop="goToHome()">
                <span class="subhead strong">Share of Voice</span>
              </div>
              <div class="map_container__map_nav__content__top__icons">
                <i
                  ref="btnClose"
                  :class="['adx-ic_close', inputSearch.length > 0 ? 'visible': '']"
                  @click.stop="clearSearch()"
                ></i>
                <div ref="searchWrapper" class="ic-search-wrapper">
                  <i class="adx-ic_search" @click.stop="toggleSearchBox()"></i>
                </div>
              </div>
              <div ref="searchBox" class="map_container__map_nav__content__top__search_box">
                <input
                  type="text"
                  name="search"
                  id="search"
                  class="search_input mini-font search"
                  v-model="inputSearch"
                  placeholder="Type a code"
                  ref="inputSearch"
                  v-on:keyup.enter="searchCode"
                />
              </div>
            </div>
            <div class="map_container__map_nav__content__mid">
              <div class="map_container__map_nav__content__mid__header">
                <span class="mini-font strong city_header">CITY</span>
                <span
                  ref="selectedCity"
                  class="mini-font"
                >{{ selectedCity ? `${selectedCityDisplay}` : '' }}</span>
              </div>
              <div class="map_container__map_nav__content__mid__search_box">
                <input 
                v-model="searchCity" 
                type="text" 
                placeholder="Search City"
                class="mini-font search">
                <i class="adx-ic_search"></i>
              </div>
              <div class="map_container__map_nav__content__mid__city">
                <ul id="cities" class="cities">
                  <li
                    v-for="city in filteredCity"
                    :key="city.id"
                    @click="selectCity(city.id, city.name)"
                  >
                    <div :class="['city', city.id == selectedCity ? 'active' : '']">
                      <a class="mini-font city_name">{{ city.name }}</a>
                      <div class="city_right">
                        <i class="adx-ic_check"></i>
                        <span v-if="city.total && selectedPlacement != 1">{{ city.total }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="map_container__map_nav__content__industry">
              <div class="map_container__map_nav__content__industry__header" @click.stop="toogleExpand('industry')">
                <div>
                  <span class="mini-font strong city_header">INDUSTRY</span>
                  <span
                    ref="selectedIndustry"
                    class="mini-font"
                  >{{ selectedIndustry ? `${selectedIndustryDisplay}` : 'All' }}</span>
                </div>
                <div class="chevron-button">
                  <i :class="[ isShownIndustry ? ' icon-chevronup' : 'icon-chevrondown']"></i>
                </div>
              </div>
              <div class="map_container__map_nav__content__industry__list" v-if="isShownIndustry">
                <div v-for="industry in industriesFilter" :key="industry.category">
                  <div class="map_container__map_nav__content__industry__list__group" @click.stop="toogleIndustryExpand(industry)">
                    <div class="arrow" :key="renderKey">
                      <i :class="[expandSubIndustry[`${industry.category}`] ? ' icon-chevronup' : 'icon-chevrondown']"></i>
                    </div>
                    <a :class="['mini-font industry', isParentIndustrySelected(industry, selectedIndustry)? 'strong' : '']">{{industry.category}}</a>
                  </div>
                  <ul id="cities" class="industries" v-if="isShownSubIndustry[`${industry.category}`]">
                    <li
                      v-for="ids in industry.list"
                      :key="ids.id"
                      @click="selectIndustry(ids.id, ids.name)">
                      <div :class="['city', ids.id == selectedIndustry ? 'active' : '']">
                        <a :class="['mini-font city_name', ids.id == selectedIndustry ? 'strong' : '']">{{ ids.name }}</a>
                        <i class="adx-ic_check"></i>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="map_container__map_nav__content__bottom__actions" v-if="isShownIndustry">
                <span class="mini-font strong reset" @click.stop="resetIndustry">Clear All</span>
              </div>
            </div>
            <div
              class="map_container__map_nav__content__bottom">
              <div class="map_container__map_nav__content__bottom__header" @click.stop="toogleExpand('brand')">
                <div>
                  <span class="mini-font strong type_header">BRAND</span>
                  <span v-if="selectedPlacement != 1"
                    class="mini-font"
                    ref="totalSelectedType"
                  >{{ listCheckedBrand.length > 0 ? `${listCheckedBrand.length} selected` : '' }}</span>
                </div>
                <div class="chevron-button">
                  <i :class="[isShownBrand ? ' icon-chevronup' : 'icon-chevrondown']"></i>
                </div>
              </div>
              <div class="map_container__map_nav__content__bottom__search_box" v-if="isShownBrand">
                <input 
                v-model="searchBrand" 
                type="text" 
                placeholder="Search Brand"
                class="mini-font search">
                <i class="adx-ic_search"></i>
              </div>
              <div class="map_container__map_nav__content__bottom__brand" v-if="isShownBrand && selectedPlacement != 1">
                <div class="list_brand" @click.stop="selectBrand(-1)">
                  <div class="left_section">
                    <span :class="['checkbox', listCheckedBrand.includes(-1) ? 'active' : '']">
                      <i class="adx-ic_check"></i>
                    </span>
                    <span class="mini-font media_text">Blanks</span>
                  </div>
                </div>
                <!-- end blanks section -->
                <div
                  v-for="(brand, index) in filteredBrand"
                  :key="index"
                  class="list_brand"
                  @click.stop="selectBrand(brand.id)"
                >
                  <div class="left_section">
                    <span
                      :class="['checkbox', listCheckedBrand.includes(brand.id) ? 'active' : '']"
                    >
                      <i class="adx-ic_check"></i>
                    </span>
                    <span class="mini-font media_text">{{ brand.name }}</span>
                  </div>
                </div>
              </div>
              <div class="map_container__map_nav__content__bottom__brand" v-else-if="isShownBrand && selectedPlacement == 1">
                <div class="list_brand"> 
                  <div class="left_section">
                    <span class="mini-font media_text">There is no brands to show right now</span>
                  </div>
                </div>
              </div>
              <div class="map_container__map_nav__content__bottom__actions" v-if="isShownBrand">
                <span v-if="(filteredBrand.length + 1) == listCheckedBrand.length" class="mini-font strong reset" @click.stop="clearFilterBrand()">Clear All</span>
                <span v-else class="mini-font strong reset" @click.stop="toggleAllBrand()">Select All</span>
                <span class="mini-font strong apply" @click.stop="applyFilter('brand')">Apply</span>
              </div>
            </div>
            <div class="map_container__map_nav__content__bottom" @click.stop="toogleExpand('type')">
              <div class="map_container__map_nav__content__bottom__header">
                <div>
                  <span class="mini-font strong type_header">MEDIA TYPE</span>
                  <span
                    class="mini-font"
                    ref="totalSelectedType"
                  >{{ listCheckedType.length > 0 ? `${listCheckedType.length} selected` : '' }}</span>
                </div>
                <div class="chevron-button">
                  <i :class="[isShownType ? ' icon-chevronup' : 'icon-chevrondown']"></i>
                </div>
              </div>
              <div class="map_container__map_nav__content__bottom__types" v-if="isShownType">
                <div
                  v-for="(media, index) in listType"
                  :key="index"
                  class="list_type"
                  @click.stop="selectType(media.name)"
                >
                  <div class="left_section">
                    <span
                      :class="['checkbox', listCheckedType.includes(media.name) ? 'active' : '']"
                    >
                      <i class="adx-ic_check"></i>
                    </span>
                    <span class="mini-font media_text">{{ media.name }}</span>
                  </div>
                  <span class="media_icon">
                    <img :src="getIconMediaType(media.name)" />
                  </span>
                </div>
              </div>
              <div class="map_container__map_nav__content__bottom__actions" v-if="isShownType">
                <span v-if="listType.length == listCheckedType.length" class="mini-font strong reset" @click.stop="cleaFilterType()">Clear All</span>
                <span v-else class="mini-font strong reset" @click.stop="toggleAllMediaType()">Select All</span>
                <span class="mini-font strong apply" @click.stop="applyFilter('media_type')">Apply</span>
              </div>
            </div>
            <div class="map_container__map_nav__content__placement" >
              <div class="map_container__map_nav__content__placement__header" @click.stop="toogleExpand('placement')">
                <div>
                  <span class="mini-font strong city_header">PLACEMENT</span>
                  <span
                    ref="selectedPlacement"
                    class="mini-font"
                  >{{ selectedPlacementDisplay }}</span>
                </div>
                <div class="chevron-button">
                  <i :class="[ isShownPlacement ? ' icon-chevronup' : 'icon-chevrondown']"></i>
                </div>
              </div>
              <div class="map_container__map_nav__content__placement__list" v-if="isShownPlacement">
                <ul id="cities" class="cities">
                  <li
                    v-for="placement in placementFilter"
                    :key="placement.id"
                    @click.stop="selectPlacement(placement.value, placement.label)"
                  >
                    <div :class="['city', placement.value == selectedPlacement ? 'active' : '']">
                      <a class="mini-font city_name">{{ placement.label }}</a>
                      <div class="city_right">
                      <i class="adx-ic_check"></i>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="isStaff || isSuperuser" class="map_container__map_nav__content__bottom">
              <div class="map_container__map_nav__content__bottom__header" @click.stop="toogleExpand('route')">
                <div>
                  <span class="mini-font strong type_header">ROUTE</span>
                  <span class="mini-font" ref="totalSelectedType">{{ listCheckedRoute.length > 0 && listCheckedRoute.includes(-1) ? `${listCheckedRoute.length - 1} selected` : listCheckedRoute.length > 0 ? `${listCheckedRoute.length} selected` : '' }}</span>
                </div>
                <div class="chevron-button">
                  <i :class="[isShownRoute ? ' icon-chevronup' : 'icon-chevrondown']"></i>
                </div>
              </div>
              <div class="map_container__map_nav__content__bottom__search_box" v-if="isShownRoute">
                <input v-model="searchRoute" type="text" placeholder="Search Route" class="mini-font search">
                <i class="adx-ic_search"></i>
              </div>
              <div class="map_container__map_nav__content__bottom__route" v-if="isShownRoute">
                <div v-for="(route, index) in filteredRoute" :key="index" class="list_route" @click.stop="selectRoute(route.id)">
                  <div class="left_section">
                    <span :class="['checkbox', listCheckedRoute.includes(route.id) ? 'active' : '']">
                      <i class="adx-ic_check"></i>
                    </span>
                    <span class="mini-font media_text">{{ route.name }}</span>
                  </div>
                </div>
              </div>
              <div class="map_container__map_nav__content__bottom__actions" v-if="isShownRoute">
                <span v-if="listCheckedRoute.includes(-1)" class="mini-font strong reset" @click.stop="clearFilterRoute()">Clear All</span>
                <span v-else-if="filteredRoute.length  == listCheckedRoute.length" class="mini-font strong reset" @click.stop="clearFilterRoute()">Clear All</span>
                <span v-else class="mini-font strong reset" @click.stop="toggleAllRoute()">Select All</span>
                <span class="mini-font strong apply" @click.stop="applyFilter('route')">Apply</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="modal-edit">
      <adx-modal v-if="isShownModalEdit" :key="componentEditKey + 'A'" @modal-close="toggleModalEdit" :hideClose="true" type="small" class="modalDeep">
        <div slot="content" class="edit__modal" v-bind:style="{height : getHeight()}">
            <i class="icon-close large-font color-grey" @click.stop="toggleModalEdit"></i>
            <h1 class="title large-font">Edit Placement</h1>
            <div v-if="placements.placement.length > 1" class="inline">
              <div class="delete placement" @click="toggleModalDeletePlacement">
                <img src="img/icons/adx-ic-delete.png">
                <span>Placement</span>
              </div>
            </div>
            <div class="subTitle">Advertising</div>
            <div class="inline">
              <adx-single-search-dropdown :label="`Brand`" :value.sync="model.brand" @selected="changeEmpty" :optionsParam="BrandListOption" class="selectTop"></adx-single-search-dropdown>
              <div class="addBrand" @click="toggleModalBrand"><img src="img/icons/adx-ic-plus.png"></div>
            </div>
            <adx-textarea :label="`Message`" :value.sync="model.message" class="textArea" />
            <div class="inline top">
              <div class="uploadImage">
                <input type="file" accept="image/*" @change="getFileThumbnail($event)" :id="`fileUpload1`" style="display: none;">
                <label :for="`fileUpload1`" class="button" >Upload</label>
                <span class="top">Thumbnail Images</span>
                <span class="bottom">{{labelThumb}}</span>
              </div>
              <div class="uploadImage right">
                <input type="file" accept="image/*" @change="getFileImage($event)" :id="`fileUpload2`" style="display: none;">
                <label :for="`fileUpload2`" class="button" >Upload</label>
                <span class="top">Full Size Images</span>
                <span class="bottom">{{labelImg}}</span>
              </div>
            </div>
            <adx-checkbox :label="'This Placement is Empty'" :value.sync="model.is_empty" class="checkboxPlacement" />
            <div class="expandEdit" @click.stop="expandEdit()">
              <div>
                <span>Placement Detail</span>
              </div>
              <div class="line"></div>
              <div class="chevron-button">
                <i :class="[ isShownEdit ? ' icon-chevronup' : 'icon-chevrondown']"></i>
              </div>
            </div>
            <div v-if="isShownEdit">
            <div class="inline">
              <div class="codeInfo codeInfoBackground">
                <span class="topInfo">Code</span>
                <span class="bottomInfo">{{codeEdit}}</span>
              </div>
              <adx-select-dropdown :label="`Media Type`" :value.sync="model.sov.billboard_type" :options="MediaListOption" class="selectRight" />
            </div>
            <div class="inline">
              <adx-input :label="`Latitude`" :value.sync="model.sov.lat"  class="inputBoxLeft"/>
              <adx-input :label="`Longitude`" :value.sync="model.sov.lon" class="inputBoxRight"/>
            </div>
            <div class="inline">
              <adx-input :label="`Media Owner`" :value.sync="model.sov.vendor" class="inputBoxLeft"/>
              <adx-input :label="`Phone Number`" :value.sync="model.sov.phone" class="inputBoxRight"/>
            </div>
            <div class="inline">
              <adx-select-dropdown :label="`Road Side`" :value.sync="model.sov.road_side" :options="RoadListOption" class="selectLeft" />
              <adx-input :label="`Road To`" :value.sync="model.road_to" class="inputBoxRight"/>
            </div>
            <div class="inline">
              <adx-single-search-dropdown :label="`Select Route`" :value.sync="model.sov.route" :optionsParam="RouteListOption" class="selectRoute"></adx-single-search-dropdown>
              <adx-input :label="`Billboard Side`" :value.sync="model.side" class="inputBoxRight"/>
            </div>
            <adx-textarea :label="`Note`" :value.sync="model.note" class="textArea" />
            <adx-checkbox :label="'This Placement is Blur'" :value.sync="model.is_blur" class="checkboxPlacement"/>
            </div>
            <div class="inline">
              <div class="delete" @click="toggleModalDeleteLoc">
                <img src="img/icons/adx-ic-delete.png">
                <span>Location</span>
              </div>
              <button class="btn-regular secondary cancel" @click="toggleModalEdit">Cancel</button>
              <button class="btn-regular primary save" @click="updateDetail('update')">Save</button>
            </div>
        </div>
      </adx-modal>
      <adx-modal v-if="isShownModalBrand" :key="componentKey" @modal-close="toggleModalBrand" :hideClose="true" type="small" class="modalDeep">
        <div slot="content" class="edit__modal brand">
          <i class="icon-close large-font color-grey" @click="toggleModalBrand"></i>
          <adx-input :label="`Brand Name`" :value.sync="NewBrand"/>
          <h1 class="title large-font">New Brand</h1>
          <div class="inline top">
            <adx-select-dropdown :label="`Industry`" :options="IndustryListOption" :value.sync="NewIndustry" @selected="changeIndustry" class="selectLeft" />
            <adx-select-dropdown :label="`Sub Categories`" :options="CategoriesListOption" :value.sync="NewCategories" class="selectRight" />
          </div>
            <div class="inline">
              <button class="btn-regular secondary" @click="toggleModalBrand">Cancel</button>
              <button class="btn-regular primary saveBrand" @click="createBrand()" >Save</button>
            </div>
        </div>
      </adx-modal>
      <adx-modal v-if="isShownModalDeleteLoc" @modal-close="toggleModalDeleteLoc" :hideClose="true" type="small" class="modalDeep">
        <div slot="content" class="edit__modal">
          <i class="icon-close large-font color-grey" @click="toggleModalDeleteLoc"></i>
          <h1 class="title large-font">Delete this Location ?</h1>
          <div class="subTitle deleteWarning">Are you sure want to delete this location with code "{{codeEdit}}" ?</div>
          <div class="subTitle deleteWarning">Notes : this proccess can’t be undo</div>
            <div class="inline">
              <button class="btn-regular secondary" @click="toggleModalDeleteLoc" >Cancel</button>
              <button class="btn-regular primary deleteBtn"  @click="updateLocation()">Delete</button>
            </div>
        </div>
      </adx-modal>
      <adx-modal v-if="isShownModalDeletePlacement" @modal-close="toggleModalDeletePlacement" :hideClose="true" type="small" class="modalDeep">
        <div slot="content" class="edit__modal">
          <i class="icon-close large-font color-grey" @click="toggleModalDeletePlacement"></i>
          <h1 class="title large-font">Delete this Placement ?</h1>
          <div class="subTitle deleteWarning">Are you sure want to delete this placement with code "{{codeEdit+model.side}}" ?</div>
          <div class="subTitle deleteWarning">Notes : this proccess can’t be undo</div>
            <div class="inline">
              <button class="btn-regular secondary" @click="toggleModalDeletePlacement" >Cancel</button>
              <button class="btn-regular primary deleteBtn" @click="updateDetail('placement')">Delete</button>
            </div>
        </div>
      </adx-modal>
    </div>
    <div class="modal-full">
      <adx-modal v-if="isShowModal" @modal-close="toggleModal" :hideClose="true" type="small">
        <div slot="content" class="history__modal">
          <div class="history__modal__header">
            <i class="icon-close large-font color-grey" @click="toggleModal"></i>
            <h1 class="title large-font">Advertising History</h1>
          </div>
          <div class="history__modal__table">
            <table class="table-placement">
              <thead>
                <tr>
                  <th class="mini-font placement-date">DATE</th>
                  <th class="mini-font placement-brand">BRAND ADVERTISER</th>
                  <th class="mini-font placement-message">MESSAGE CAMPAIGN</th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="history__modal__table tablebody">
            <table class="table-placement">
              <tbody v-if="listHistory.length > 0">
                <tr v-for="(data, index) in listHistory" :key="index">
                  <td class="placement-date">
                    <div class="item-section">
                      <span class="date">{{ displayDate(data.start_date) }}</span>
                    </div>
                  </td>
                  <td class="placement-brand">
                    <span class="brand">{{ data.brand ? data.brand : 'empty' }}</span>
                  </td>
                  <td class="placement-message">
                    <span class="message">{{ data.message ? data.message : 'empty' }}</span>
                  </td>
                </tr>
                <tr></tr>
                <tr></tr>
                <tr></tr>
              </tbody>
              <span class="empty" v-else >There is no history record at this time</span>
            </table>
          </div>
        </div>
      </adx-modal>
    </div>
  </div>
</template>

<script>
import LoadingPrimary from "@/components/Loading/Primary";
import { globalMixins } from "@/lib/mixins/globalMixins";
import InfoWindow from '@/views/SovMap/infoWindow';
import { AModal, ASingleSearchDropdown } from "ui-kit-v1"
import SelectDropdown from '@/components/Form/SelectDropdown'
import Textarea from '@/components/Form/TextArea'
import Checkbox from '@/components/Form/Checkbox'
import Input from '@/components/Form/Input'
import { mapListFilter } from '@/lib/transformer'
import axios from 'axios'
import { baseUri, accessToken } from '@/lib/config'
import store from '@/store'


import Vue from 'vue';
import api from "@/api";
import { apiV2 } from "@/api/urls";
import { mapGetters } from "vuex";
import lib from '@/lib/util'
import moment from 'moment';

export default {
  name: "adx-billboard-map",
  components: {
    "adx-loading": LoadingPrimary,
    "info-window": InfoWindow,
    "adx-modal": AModal,
    'adx-select-dropdown': SelectDropdown,
    'adx-textarea': Textarea,
    'adx-checkbox': Checkbox,
    'adx-input': Input,
    "adx-single-search-dropdown": ASingleSearchDropdown
  },
  mixins: [globalMixins],
  created() {
    this.loadFilter();
    this.loadCode();
    this.loadBillboard();
    this.loadListRoute();
  },
  data() {
    return {
      allSelected: true,
      isStaff: null,
      isSuperuser: null, 
      mapOptions: {
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false
      },
      toggleSide: true,
      toggleButton: false,
      listStreet: [],
      listCity: [],
      center: { lat: -6.208049, lng: 106.844379 }, // jakarta as a default center view
      defaultCenter: { lat: -6.208049, lng: 106.844379 },
      zoom: 7,
      polyLineOpts: {
        strokeColor: "#2106f9"
      },
      streetCoordinates: [],
      searchBrand: "",
      searchCity: "",
      searchRoute: "",
      selectedCity: null,
      selectedPlacement: 2,
      selectedPlacementDisplay: "Placement With Ads",
      selectedIndustry: null,
      selectedIndustryDisplay: null,
      selectedCityDisplay: "",
      infoWindowPosition: null,
      infoWindowOptions: {
        content: ""
      },
      infoWindowOpen: false,
      renderKey: 0,
      currentWindow: null,
      loadDataStreet: true,
      loadDataCity: true,
      loadingMap: true,
      loadDataBillboard: true,
      listBillboard: [],
      listBillboardFull: [],
      filteredBillboard: [],
      markers: [],
      // current marker index
      currentMidx: null,
      infoWindowBillboard: {
        content: ""
      },
      infoWindowBillboardOpen: false,
      infoWindowBillboardPosition: null,
      initialBrand: true,
      listType: [],
      listBrand: [],
      listBrandFull: [],
      listCheckedType: [],
      listCheckedBrand: [],
      listCheckedRoute: [],
      listIndustry: [],
      listRoute: [],
      timeout: null,
      requesting: false,
      billboardAsCenter: false,
      billboardCenter: null,
      inputSearch: "",
      listCode: [],
      filteredCode: [],
      selectedCode: "",
      isShownType: false,
      expandType: false,
      isShownBrand: false,
      expandBrand: false,
      isShownPlacement: false,
      expandPlacement: false,
      isShownIndustry: false,
      expandIndustry: false,
      isShownRoute: false,
      isShownSubIndustry:{},
      expandSubIndustry:{},
      industriesFilter: [],
      placements: null,
      id_edit: null,
      isShownModalEdit: false,
      isShownModalBrand: false,
      isShownModalDeleteLoc: false,
      isShownModalDeletePlacement: false,
      isShownEdit: false,
      BrandListOption: [],
      MediaListOption: [],
      RouteListOption: [],
      IndustryListOption: [],
      IndustryList: [],
      CategoriesListOption: [],
      NewBrand: '',
      NewIndustry: '',
      oldIndustry: '',
      NewCategories: null,
      componentKey: 0,
      componentEditKey: 0,
      componentWindowKey: 0,
      labelImg: 'File jpg or png',
      labelThumb: 'File jpg or png',
      billboardId: null,
      model :{
        brand: null,
        sov:{
          id: null,
          code: '',
          billboard_type: '',
          lon: '',
          lat: '',
          vendor: '',
          phone: '',
          road_side: null,
          route: null
        },
        codeEdit: '',
        message: '',
        is_empty: null,
        road_to: '',
        side: '',
        note: '',
        is_blur: null,
      },
      RoadListOption: [
        {
          id: 1,
          value: 1,
          label: "Left"
        },
        {
          id: 2,
          value: 2,
          label: "Right"
        },
        {
          id: 3,
          value: 3,
          label: "Middle"
        }
      ],
      isShowModal: false,
      modalChanged: false,
      listHistory: [],
      industryFinancialFilter: [
        {
          id: 0,
          value: null,
          label: "All Financial"
        },
        {
          id: 1,
          value: 'bank',
          label: "Bank"
        }
      ],
      industryFoodFilter: [
        {
          id: 0,
          value: null,
          label: "All Food"
        }
      ],
      placementFilter: [
        {
          id: 0,
          value: 0,
          label: "All"
        },
        {
          id: 1,
          value: 1,
          label: "Empty Placement"
        },
        {
          id: 2,
          value: 2,
          label: "Placement With Ads"
        }
      ],
      zoomLevel: 13,
      standardZoomLevel: 13
    };
  },
  watch: {
    billboardAsCenter: function(newValue, oldValue) {
      if (newValue) {
        this.useBillboardCenter();
      }
    },
    billboardCenter: function(newValue, oldValue) {
      if (newValue) {
        this.useBillboardCenter();
      }
    },
    searchBrand: function(newValue, oldValue) {
      if (newValue && this.initialBrand == true) {
        this.initialBrand = false
        this.clearFilterBrand();
      }
    }
  },
  mounted() {
    this.isStaff = this.account.isStaff;
    this.isSuperuser = this.account.isSuperuser;
    this.$nextTick(function() {
      // Vue.$broker.$on("app-click", this.windowClicked.bind(this))
    })
  },
  methods: {
    windowClicked() {
      if (this.infoWindowBillboardOpen) {
        this.closeWindowBillboard()
      }
    },
    toggleAllBrand() {
      // this.allSelected = !this.allSelected
      // if (this.allSelected) {
      this.listCheckedBrand = [-1]
      this.listBrand.forEach(record => {
        this.listCheckedBrand.push(record.id);
      });
      // } else {
      //   this.listCheckedBrand = []
      // }
    },
    toggleAllMediaType() {
      this.listCheckedType = []
      this.listType.forEach(record => {
        this.listCheckedType.push(record.name);
      });
    },
    toggleAllRoute() {
      this.listCheckedRoute = []
      this.listRoute.forEach(record => {
        this.listCheckedRoute.push(record.id);
      });
    },
    showMap() {
      this.loadingMap = false;
    },
    loadBillboard() {
      (async () => {
        this.loadDataBillboard = true;
        this.listBillboard = [];

        let params = {
          city: this.selectedCity || undefined
        };
        const response = await api.get(apiV2.sovListLocation, {
          needToken: true,
          params: params
        });
        if (response.status == 200) {
          this.listBillboard = response.data;
          this.listBillboardFull = response.data;
          let coordinate = {}
          if(this.listBillboard.length>0){
            coordinate.latitude=parseFloat(this.listBillboard[0].lat),
            coordinate.longitude=parseFloat(this.listBillboard[0].lon)
          }
          if (
            coordinate.latitude &&
            coordinate.longitude &&
            !this.billboardAsCenter
          ) {
            coordinate = this.transformCoordinate(coordinate);
            this.changeCenterAndZoom(coordinate);
          } else {
            this.billboardAsCenter = true;
          }
          this.filterBillboardByCode();
          this.loadFilteredBilboard();
          this.loadDataBillboard = false;
          this.loadingMap = false;
          this.zoomLevel = this.standardZoomLevel;
        }
      })();
    },
    isParentIndustrySelected(industry, selectedIndustry) {
      let selected = industry.list.filter(el => {
        return el.id == selectedIndustry
      })
      return selected.length > 0
    },
    isBrandExist(billboard, brandQuery, ids, isIndustry, isNotEmpty = false){
      let exist = false
      billboard.placement.map(el => {
        if (el.brand) {
          if (isIndustry) {
            if (ids.includes(el.brand.industry)) {
              exist = true
            }
          } else {
            if (ids.includes(el.brand.id)) {
              exist = true
            }
          }
        } else {
          if (!isNotEmpty && brandQuery.includes(-1)) {
            exist = true
          }
        }
      })
      return exist
    },
    loadFilteredBilboard(){
        let params = {
          city: this.selectedCity || undefined,
          brand: brandQuery,
          media_type: this.listCheckedType,
          empty: this.selectedPlacement || undefined,
          industry: this.selectedIndustry || undefined
        };

      this.filteredBillboard = this.listBillboardFull
    
      //filter media_type
      this.filteredBillboard = this.filteredBillboard.filter(billboard => {
        return params.media_type.includes(billboard.media_type)
      })

      //filter route
      let routeQuery = this.listCheckedRoute
      this.filteredBillboard = this.filteredBillboard.filter(billboard => {
        if(billboard.route){
          return routeQuery.includes(billboard.route.id)
        }else if(routeQuery.includes(-1)){
          return billboard.route == null
        }
      })
      
      //filter industry
      if (this.selectedIndustry) {
        let prefix = (this.selectedIndustry+'').substr(0, 3)
        let ids = []
        let isAll = true

        if (prefix == 'all'){
          let key = (this.selectedIndustry+'').substr(3)
          this.industriesFilter.map(industry => {
            if (industry.category==key) {
              industry.list.map(x=>{ids.push(x.id)})
            }
          })
          this.filteredBillboard = this.filteredBillboard.filter(billboard => {
            if (billboard.placement.length > 0) {
              return this.isBrandExist(billboard, brandQuery, ids, true, true)
            }

            return false
          }) 
        } else {
          isAll = false
          this.filteredBillboard = this.filteredBillboard.filter(billboard => {
            if (billboard.placement.length > 0) {

              let bb = billboard.placement.filter(el => {
                if (el.brand) {
                  if (this.selectedIndustry == el.brand.industry) return true
                }
              })
              return bb.length > 0  
            }
          })
        }
        if(this.selectedIndustry != this.oldIndustry){
          this.oldIndustry = this.selectedIndustry
          this.updateBrandOptions(isAll,ids)
        }
      }

      //filter brand
      let brandQuery = this.listCheckedBrand
      this.filteredBillboard = this.filteredBillboard.filter(billboard => {
        if (billboard.placement.length > 0) {
          return this.isBrandExist(billboard, brandQuery, brandQuery, false, false)
        } else {
          if (brandQuery.includes(-1)) {
            return true
          }
        }
        return false
      })
      
      //filter placement
      this.filteredBillboard = this.filteredBillboard.filter(billboard => {
        let placement_empty = 0
        let placement_notempty = 0

        billboard.placement.map(el =>{
          el.is_empty ? placement_empty += 1 :  placement_notempty += 1
        })

        if (billboard.placement.length > 0) {
          if (this.selectedPlacement === 1) {
            if (placement_empty > 0) {
              return true
            }
          } else if (this.selectedPlacement === 2) {
            if (placement_notempty > 0) {
              return true
            }
          } else {
            if (placement_empty > 0 || placement_notempty > 0) {
              return true
            }
          }
        }
      })
      
      this.loadFilterCity()
      this.setBillboardCenter();
      this.mappingBillboardMarker();
    },
    loadFilterCity(){
      (async () => {
        //kalo id -1 ganti null aja
        let brandQuery = this.listCheckedBrand.join(`,`) || undefined

        
        const response = await api.get(apiV2.sovFilterCity, {
          needToken: true,
          params: {brand: brandQuery}
        });
        if (response.status == 200) {
          let brandCities = {}
          for (let data of response.data){
            brandCities[data.name] = data.total_brand
          } 
          let updatedCity = []
          for (let city of this.listCity){

            updatedCity.push({
              ...city,
              'total': brandCities[city.name] ? brandCities[city.name] : 0
            })

          } 
          this.listCity = updatedCity
        }
      })();
    },
    updateBrandOptions(isAll,ids){
      this.filteredBrand
      this.listBrand = this.listBrandFull
      let replaceBrand = []
      if (isAll) {
        if (ids.length > 0) {
          this.listBrand.map((brand) => {
          if (ids.includes(brand.industry)) replaceBrand.push(brand)
          })

          this.listBrand = replaceBrand
          this.updateCheckedBrand()
        }
      } else {
        if (this.selectedIndustry) {
          this.listBrand.map((brand) => {
            if (brand.industry == this.selectedIndustry) replaceBrand.push(brand)
            })
          this.listBrand = replaceBrand
          this.updateCheckedBrand()
        }
      }
    },
    filterBillboardByCode() {
      if (this.selectedCode) {
        this.filteredBillboard = this.listBillboard.filter(billboard => {
          return (
            billboard.code.toLowerCase() == this.selectedCode.toLowerCase()
          );
        });
        if (this.filteredBillboard.length == 0) {
          this.showNotificationAlert("Error", "Data not found.", "danger");
          return;
        }
      } else {
        this.filteredBillboard = this.listBillboard;
      }
      this.setBillboardCenter();
      this.mappingBillboardMarker();
    },
    loadCode() {
      (async () => {
        const response = await api.get(apiV2.sovListCode, { needToken: true });
        if (response.status == 200) {
          this.listCode = response.data;
        }
      })();
    },
    loadFilter() {
      (async () => {
        const response = await api.get(apiV2.sovFilter, { needToken: true });
        if (response.status == 200) {
          // load data cities
          for (let city of response.data.cities) {
            city.total = 0
          }
          this.listCity = response.data.cities;
          this.loadDataCity = false;

          // load data brands
          this.listBrand = response.data.brands;
          this.listBrandFull = response.data.brands
          this.listCheckedBrand.push(-1)
          this.listBrand.forEach(record => {
            this.listCheckedBrand.push(record.id);
          });
          

          let industries = []
          Object.keys(response.data.industry).sort().map((key, index) => {
            let all = [{
              id: 'all'+key,
              name: "All " + key
            }]

            industries.push({
              category: key,
              list: [...all,...response.data.industry[key]]
            })
            this.isShownSubIndustry[key] = false
            this.expandSubIndustry[key] = false
          })

          this.industriesFilter = industries

          // load data media types
          this.listType = response.data.media_types;
          this.listType.forEach(record => {
            this.listCheckedType.push(record.name);
          });

          //load data list for edit placements
          this.BrandListOption = mapListFilter({obj: response.data.brands, id:`id`, value:`id`, label: `name`})
          this.BrandListOption.unshift({id : null, value: 'null', label: '---'})
          this.MediaListOption = mapListFilter({obj: response.data.media_types, value:`key`, label: `name`})
      
          var listIndustry = Object.getOwnPropertyNames(response.data.industry)
          listIndustry.forEach(element =>  this.IndustryListOption.push({id: null, label: element, value: element}));

          this.IndustryList = response.data.industry
        }
      })();
    },
    loadListRoute(){
      (async () => {
        const response = await api.get(apiV2.sovListRoute, { needToken: true });
        if (response.status == 200) {
          this.RouteListOption = mapListFilter({obj: response.data, id:`id`, value:`id`, label: `name`})
          this.listRoute = response.data
          this.listRoute.forEach(record => {
            this.listCheckedRoute.push(record.id);
          });
          this.listCheckedRoute.unshift(-1);
        }
      })();

    },
    resetFilter(){
      this.selectedCity = null
      this.selectedIndustry = null
      this.selectedPlacement = 2
      this.selectedPlacementDisplay = "Placement With Ads"
      this.listCheckedBrand = [-1]
      this.listCheckedType = []
      this.listCheckedRoute = []
    
      this.listBrand = this.listBrandFull
      this.listBrand.forEach(record => {
        this.listCheckedBrand.push(record.id);
      });
      this.listType.forEach(record => {
        this.listCheckedType.push(record.name);
      });
      this.listRoute.forEach(record => {
        this.listCheckedRoute.push(record.id);
      });
      this.listCheckedRoute.unshift(-1)

    },
    updateCheckedBrand(){
      this.listCheckedBrand = [-1]
      this.listBrand.forEach(record => {
        this.listCheckedBrand.push(record.id);
      });
    },
    mappingBillboardMarker() {
      this.markers = [];
      this.filteredBillboard.forEach(record => {
        let coordinate = this.transformCoordinate({
          latitude: record.lat,
          longitude: record.lon
        });
        this.markers.push({
          id: record.id,
          position: coordinate,
          record: record
        });
      });
    },
    setBillboardCenter() {
      if (this.filteredBillboard.length == 1) {
        let record = this.filteredBillboard[0];
        this.billboardCenter = this.transformCoordinate({
          latitude: record.lat,
          longitude: record.lon
        });
      } else if (this.filteredBillboard.length > 1) {
        // get the first one record that has lat and long attribute
        // and use as the center
        for (let record of this.filteredBillboard) {
          if (record.lat && record.lon) {
            let coordinate = this.transformCoordinate({
              latitude: record.lat,
              longitude: record.lon
            });
            this.billboardCenter = coordinate;
            break;
          }
        }
      }
    },
    changeCity(id, name) {
      // select the city, and load the streets
      // this.initialBrand = true
      this.loadingMap = true;
      this.selectedCity = id;
      this.selectedCityDisplay = name;
      this.closeWindowBillboard();
      this.loadBillboard();
    },
    selectCity(id, name) {
      if (id != this.selectedCity) {
        // this.resetFilter()
        this.selectedCode = "";
        this.inputSearch = "";
        this.resetCenter();
        this.changeCity(id, name);
      }
    },
    selectPlacement(value, name) {
      this.selectedPlacement = value;
      this.selectedPlacementDisplay = name;
      // this.loadBillboard();
      this.loadFilteredBilboard('placement')
      this.isShownPlacement = true;
      // this.expandPlacement = true;
    },
    selectIndustry(value, name) {
      this.selectedIndustry = value;
      this.selectedIndustryDisplay = name;
      // this.oldIndustry =  value;
      // this.loadBillboard();
      this.loadFilteredBilboard('industry')
      this.isShownIndustry = true;
      // this.expandIndustry = true;
    },
    resetIndustry(){
      this.selectedIndustry = null;
      this.selectedIndustryDisplay = null;
      this.listBrand = this.listBrandFull
      this.updateCheckedBrand()
      this.loadFilteredBilboard()
      this.isShownIndustry = true;
    },
    selectType(type) {
      if (this.listCheckedType.includes(type)) {
        let index = this.listCheckedType.indexOf(type);
        if (index > -1) {
          this.listCheckedType.splice(index, 1);
        }
      } else {
        this.listCheckedType.push(type);
      }
    },
    selectBrand(brand) {
      if (this.listCheckedBrand.includes(brand)) {
        let index = this.listCheckedBrand.indexOf(brand);
        if (index > -1) {
          this.listCheckedBrand.splice(index, 1);
        }
      } else {
        this.listCheckedBrand.push(brand);
      }
    },
    selectRoute(route) {
      if(this.listCheckedRoute.includes(-1)){
        this.listCheckedRoute.shift()
      }
      if (this.listCheckedRoute.includes(route)) {
        let index = this.listCheckedRoute.indexOf(route);
        if (index > -1) {
          this.listCheckedRoute.splice(index, 1);
        }
      } else {
        this.listCheckedRoute.push(route);
      }
    },
    changeCenterAndZoom(coordinate) {
      this.center = coordinate;
      this.zoom = 13;
    },
    transformAllCoordinate(coordinates) {
      let newData = [];
      coordinates.forEach(coordinate => {
        newData.push(this.transformCoordinate(coordinate));
      });

      return newData;
    },
    transformCoordinate(coordinate) {
      return {
        lat: parseFloat(coordinate.latitude),
        lng: parseFloat(coordinate.longitude)
      };
    },
    toggleInfoWindowMarker(marker, idx) {
      this.billboardId = marker.record.id
      if(this.placements == marker.record){
        //for re-render info window
        this.componentWindowKey += 1;
      }else{
        this.placements = marker.record
      }
      this.infoWindowBillboardPosition = marker.position;
      //this.infoWindowBillboard.content = this.renderInfoWindowMarker(marker.record);

      if (this.currentMidx == idx) {
        this.infoWindowBillboardOpen = !this.infoWindowBillboardOpen;
      } else {
        this.infoWindowBillboardOpen = true;
        this.currentMidx = idx;
      }
    },
    closeWindowBillboard() {
      this.infoWindowBillboardOpen = false;
      this.currentMidx = null;
    },
    renderInfoWindowMarker(data) {
      return `${this.$refs['window'].$el.outerHTML}`
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    applyFilter(type) {
      if (this.requesting) return;
      let _this = this;
      this.timeout = setTimeout(() => {
        _this.requestFinish();
      }, 3000);
      this.requesting = true;
      // this.loadBillboard();
      this.loadFilteredBilboard(type)
    },
    requestFinish() {
      this.requesting = false;
    },
    cleaFilterType() {
      this.listCheckedType = [];
    },
    clearFilterBrand() {
      this.listCheckedBrand = [];
    },
    clearFilterRoute() {
      this.listCheckedRoute = [];
    },
    getZoom(zoomLevel) {
      this.zoomLevel = zoomLevel;
    },
    getIcon(data) {
      if (this.zoomLevel <= 6) this.zoomLevel = 6;
      let scaler = this.zoomLevel < this.standardZoomLevel ? 4 * (this.zoomLevel - this.standardZoomLevel) : 0;
      let icon = {scaledSize: { width: 32 + scaler, height: 32 + scaler }};
      if(data.placement.length > 1){
        icon.url = this.getIconMultipleMarker(data.media_type, data.placement)
      }else{
        if (data.placement[0].is_empty == true) {
          icon.url = this.getIconMarker(data.media_type, true);
        } else {
          icon.url = this.getIconMarker(data.media_type, false);
        }
      }

      return icon;
    },
    getIconMediaType(mediaType) {
      let iconUrl = "/img/icons/sov";
      switch (mediaType.toLowerCase()) {
        case "billboard":
          iconUrl = `${iconUrl}/ic-map-billboard-new1.png`;
          break;
        case "baliho":
          iconUrl = `${iconUrl}/ic-map-baliho-new1.png`;
          break;
        case "bando":
          iconUrl = `${iconUrl}/ic-map-bando-new1.png`;
          break;
        case "jpo":
          iconUrl = `${iconUrl}/ic-map-JPO-new1.png`;
          break;
        case "videotron":
          iconUrl = `${iconUrl}/ic-map-videotron-new1.png`;
          break;
        case "street furniture digital":
          iconUrl = `${iconUrl}/ic-map-SFurniture-digital-new1.png`;
          break;
        case "street furniture static":
          iconUrl = `${iconUrl}/ic-map-SFurniture-static-new1.png`;
          break;
        default:
          iconUrl = `${iconUrl}/ic-map-billboard-new1.png`;
      }

      return iconUrl;
    },
    getIconMarker(mediaType, empty) {
      let iconUrl = "/img/icons/sov";
      if (empty) {
        if(mediaType == null){
          return `/img/icons/ic-map-gray@2x.png`;
        }
        switch (mediaType.toLowerCase()) {
          case "billboard":
            iconUrl = `${iconUrl}/ic-map-billboard-empty-new1.png`;
            break;
          case "baliho":
            iconUrl = `${iconUrl}/ic-map-baliho-empty-new1.png`;
            break;
          case "bando":
            iconUrl = `${iconUrl}/ic-map-bando-empty-new1.png`;
            break;
          case "jpo":
            iconUrl = `${iconUrl}/ic-map-JPO-empty-new1.png`;
            break;
          case "videotron":
            iconUrl = `${iconUrl}/ic-map-videotron-empty-new1.png`;
            break;
          case "street furniture digital":
            iconUrl = `${iconUrl}/ic-map-SFurniture-digital-empty-new1.png`;
            break;
          case "street furniture static":
            iconUrl = `${iconUrl}/ic-map-SFurniture-static-empty-new1.png`;
            break;
          default:
            iconUrl = `${iconUrl}/ic-map-billboard-empty-new1.png`;
        }
      } else {
        if(mediaType == null){
          return `/img/icons/ic-map-gray@2x.png`;
        }
        switch (mediaType.toLowerCase()) {
          case "billboard":
            iconUrl = `${iconUrl}/ic-map-billboard-new1.png`;
            break;
          case "baliho":
            iconUrl = `${iconUrl}/ic-map-baliho-new1.png`;
            break;
          case "bando":
            iconUrl = `${iconUrl}/ic-map-bando-new1.png`;
            break;
          case "jpo":
            iconUrl = `${iconUrl}/ic-map-JPO-new1.png`;
            break;
          case "videotron":
            iconUrl = `${iconUrl}/ic-map-videotron-new1.png`;
            break;
          case "street furniture digital":
            iconUrl = `${iconUrl}/ic-map-SFurniture-digital-new1.png`;
            break;
          case "street furniture static":
            iconUrl = `${iconUrl}/ic-map-SFurniture-static-new1.png`;
            break;
          default:
            iconUrl = `${iconUrl}/ic-map-billboard-new1.png`;
        }
      }

      return iconUrl;
    },
    getIconMultipleMarker(mediaType, placement){
      let iconUrl = '/img/icons/sov'
      let isEmpty = []
      let folder = null

      placement.map(el =>{
        isEmpty.push(el.is_empty)
      })

      //check verified for multiple placement
      if (isEmpty.includes(true) && isEmpty.includes(false)){
        folder = 'multipleside/halfcontent'
      }else if(isEmpty.every(Boolean) == true){
        folder = 'multipleside/emptycontent'
      }else if(isEmpty.every(Boolean) == false){
        folder= 'multipleside/fullcontent'
      }

      switch(mediaType.toLowerCase()) {
        case 'billboard':
          iconUrl = `${iconUrl}/${folder}/ic-map-billboard-new1.png`
          break
        case 'baliho':
          iconUrl = `${iconUrl}/${folder}/ic-map-baliho-new1.png`
          break
        case 'bando':
          iconUrl = `${iconUrl}/${folder}/ic-map-bando-new1.png`
          break
        case 'jpo':
          iconUrl = `${iconUrl}/${folder}/ic-map-JPO-new1.png`
          break
        case 'videotron':
          iconUrl = `${iconUrl}/${folder}/ic-map-videotron-new1.png`
          break
        case "street furniture digital":
          iconUrl = `${iconUrl}/${folder}/ic-map-SFurniture-digital-new1.png`;
          break
        case "street furniture static":
          iconUrl = `${iconUrl}/${folder}/ic-map-SFurniture-new1.png`;
          break
        default:
          iconUrl = `${iconUrl}/${folder}/ic-map-billboard-new1.png`
      }
      return iconUrl
    },
    isRecommendation(recommendation) {
      if (recommendation) {
        if (recommendation.toLowerCase() == "ok") {
          return true;
        }
      }

      return false;
    },
    isVideotron(type) {
      if (type) {
        if (type.toLowerCase() == "videotron") {
          return true;
        }
      }

      return false;
    },
    loadBillboardImg(photo) {
      return photo ? photo : "/img/notfound/img-placeholder-landscape@2x.png";
    },
    useBillboardCenter() {
      if (this.billboardAsCenter && this.billboardCenter) {
        this.changeCenterAndZoom(this.billboardCenter);
      }
    },
    resetCenter() {
      this.billboardAsCenter = false;
      this.billboardCenter = null;
    },
    toggleSearchBox() {
      let className = "show";
      let wrapperClassNmae = "active"
      let search = this.$refs["searchBox"];
      let searchWrapper = this.$refs["searchWrapper"]
      if (search.classList.contains(className)) {
        search.classList.remove(className);
      } else {
        search.classList.add(className);
        this.$refs["inputSearch"].focus();
      }

      if (searchWrapper.classList.contains(wrapperClassNmae)) {
        searchWrapper.classList.remove(wrapperClassNmae)
      } else {
        searchWrapper.classList.add(wrapperClassNmae)
      }
    },
    toggleSideMenu() {
      this.toggleSide = !this.toggleSide;
      this.toggleButton = !this.toggleButton;
    },
    goToHome() {
      this.$router.push({ name: "home" });
    },
    searchCode() {
      this.resetCenter();
      this.closeWindowBillboard();
      if (!this.inputSearch) {
        this.selectedCode = "";
        this.filterBillboardByCode();
        return;
      }
      this.selectedCode = this.inputSearch;
      this.selectedCode = this.selectedCode.substr(0,8)
      let selectedData = this.listCode.filter(record => {
        return record.code.toLowerCase() == this.selectedCode.toLowerCase();
      });
      if (selectedData.length > 0) {
        let data = selectedData[0];
        if (data.city.id == this.selectedCity) {
          this.billboardAsCenter = true;
          this.filterBillboardByCode();
        } else {
          this.billboardAsCenter = true;
          this.changeCity(data.city.id, data.city.name);
        }
      } else {
        this.showNotificationAlert("Error", "Data not found.", "danger");
      }
    },
    clearSearch() {
      this.inputSearch = "";
      this.selectedCode = "";
      this.filterBillboardByCode();
    },
    toogleExpand(value) {
      if (value == "type") {
        this.isShownType = !this.isShownType;
        this.isShownPlacement = false
        this.isShownBrand = false
        this.isShownIndustry = false
        this.isShownRoute = false
        // this.expandType = !this.expandType;
      } else if (value == "placement") {
        this.isShownPlacement = !this.isShownPlacement;
        this.isShownType = false
        this.isShownBrand = false
        this.isShownIndustry = false
        this.isShownRoute = false
        // this.expandPlacement = !this.expandPlacement;
      } else if (value == "brand") {
        this.isShownBrand = !this.isShownBrand;
        this.isShownPlacement = false
        this.isShownType = false
        this.isShownIndustry = false
        this.isShownRoute = false
        // this.expandBrand = !this.expandBrand;
      }  else if (value == "industry") {
        this.isShownIndustry = !this.isShownIndustry;
        this.isShownType = false
        this.isShownPlacement = false
        this.isShownBrand = false
        this.isShownRoute = false
        // this.expandIndustry = !this.expandIndustry;
      }else if(value == "route"){
        this.isShownRoute = !this.isShownRoute
        this.isShownIndustry = false
        this.isShownType = false
        this.isShownPlacement = false
        this.isShownBrand = false

      }
    },
    expandEdit(){
      this.isShownEdit = !this.isShownEdit
    },
    toogleIndustryExpand(industry){
      let show = this.isShownSubIndustry[industry.category]
      let expand = this.expandSubIndustry[industry.category]
      this.$set(this.isShownSubIndustry, industry.category, !show)
      this.$set(this.expandSubIndustry, industry.category, !expand)
      this.renderKey+=1
    },
    updateData(){
      this.infoWindowBillboard.content = this.renderInfoWindowMarker()
    },
    initialSlide(div, style){
      var empty = this.placements.placement.map( data => data.is_empty)
      var slides = document.getElementsByClassName(div);
      for (var i = 0; i < slides.length; i++){
        slides[i].style.display = "none"
      }
      if(slides.length%2 == 0){
        slides[slides.length/2 - 1].style.display = style
        if (empty[slides.length/2 - 1] == true){
          var slidesAdvert = document.getElementsByClassName("advertising");
          for (i = 0; i < slidesAdvert.length; i++) {
              slidesAdvert[i].style.display = "none";  
          }
        }else if(empty[slides.length/2 - 1] == false){
          var slidesEmpty = document.getElementsByClassName("empty");
          var slidesOwner = document.getElementsByClassName("ownerInfo");
          for (i = 0; i < slidesEmpty.length; i++) {
              slidesEmpty[i].style.display = "none";
              slidesOwner[i].style.display = "none";  
          }
        }
        if(!this.isStaff && !this.isSuperuser){
          var slidesOwner = document.getElementsByClassName("ownerInfo");
          var editDetail = document.getElementsByClassName("edit_detail");
          for (i = 0; i < slidesOwner.length; i++) {
              slidesOwner[i].style.display = "none";
              editDetail[i].style.display = "none";  
          }
        }
      }
      
    },
    toggleModalEdit(id_placement){
      this.isShownModalEdit = !this.isShownModalEdit
      if(this.isShownModalEdit == true){
        this.loadData(this.placements, id_placement)
      }
      this.labelImg = 'File jpg or png'
      this.labelThumb = 'File jpg or png'
      this.isShownEdit = false
    },
    toggleModalBrand(){
      this.NewBrand = null
      this.NewIndustry = null
      this.NewCategories = null
      this.isShownModalBrand = !this.isShownModalBrand
    },
    toggleModalDeleteLoc(){
      this.isShownModalDeleteLoc = !this.isShownModalDeleteLoc
      // this.idLocation = 
    },
    toggleModalDeletePlacement(){
      this.isShownModalDeletePlacement = !this.isShownModalDeletePlacement
    },
    getFileImage(event){
      var file = event.target.files[0]
      this.labelImg = file.name
      this.validateFile(file, 'img')
    },
    getFileThumbnail(event){
      var file = event.target.files[0]
      this.labelThumb = file.name
      this.validateFile(file, 'thumb')
    },
    validateFile(file, type){
      var form = new FormData();

      if(type == 'img'){
        form.append('image', file)
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/)
        if(image_ext_patt.test(file.name.toLowerCase()) == false){
          this.showNotificationAlert('Error', 'Unsupported file type', 'danger')
        }else{
          this.uploadPhoto(form)
        }
      }else if(type == 'thumb'){
        form.append('thumbnail', file)
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/)
        if(image_ext_patt.test(file.name.toLowerCase()) == false){
          this.showNotificationAlert('Error', 'Unsupported file type', 'danger')
        }else{
          this.uploadPhoto(form)
        }
      }
    },
    loadData(placements, id_placement){
      var dataPlacement = this.placements.placement.map(data => data)
      var dataPlacementSide = dataPlacement.filter(dataPlacement => dataPlacement.id == id_placement)
      this.id_edit = id_placement
      this.model.brand = dataPlacementSide[0].brand ? dataPlacementSide[0].brand.id : null
      this.model.sov.code = placements.code ? placements.code : null
      this.model.sov.billboard_type = this.getDetailId('media', placements.media_type)
      this.model.sov.lon = placements.lon ? placements.lon : null
      this.model.sov.lat = placements.lat ? placements.lat : null
      this.model.sov.vendor = placements.vendor ? placements.vendor : null
      this.model.sov.phone = placements.phone ? placements.phone : null
      this.model.sov.road_side = this.getDetailId('road', placements.road_side)
      this.model.sov.route = placements.route ? placements.route.id : null
      this.model.message = dataPlacementSide[0].message ? dataPlacementSide[0].message : null
      this.model.is_empty = dataPlacementSide[0].is_empty
      this.model.road_to = dataPlacementSide[0].road_to ? dataPlacementSide[0].road_to : null
      this.model.side = dataPlacementSide[0].side ? dataPlacementSide[0].side : null
      this.model.note = dataPlacementSide[0].note ? dataPlacementSide[0].note : null
      this.model.is_blur = dataPlacementSide[0].is_blur
      this.codeEdit = placements.code
    },
    getDetailId(type, data){
      var dictMedia = {'Billboard' : 'BL', 'Videotron': 'VT', 'Bando': 'BD', 'JPO': 'JP', 'Street Furniture Digital': 'FD', 'Street Furniture Static': 'FS'}
      var dictRoad = {'Left': 1, 'Right': 2, 'Middle': 3}
      if(type == 'media'){
        return dictMedia[data]
      }else if(type == 'road'){
        return dictRoad[data]
      }
    },
    getHeight(){
      if(this.isShownEdit == false){
        return '100%'
      }else{
        return '500px'
      }
    },
    reuseContent(id){
      this.updateDetail(id);
    },
    updateDetail(param){
      let body = {}
      var form = new FormData();
      let isDelete = false 
      if (param){
        param == 'update' ?  isDelete = false :  isDelete = true
        body = {
          brand: this.model.brand,
          sov:{
            id: this.placements.id,
            code: this.model.sov.code,
            billboard_type: this.model.sov.billboard_type,
            lon: this.model.sov.lon,
            lat: this.model.sov.lat,
            vendor: this.model.sov.vendor,
            phone: this.model.sov.phone,
            road_side: this.model.sov.road_side,
            route: this.model.sov.route
          },
          message: this.model.message,
          is_empty: this.model.is_empty,
          road_to: this.model.road_to,
          side: this.model.side,
          note: this.model.note,
          is_blur: this.model.is_blur,
          is_deleted: isDelete
        }
        if(this.model.brand == 'null'){
          body.brand = null
        }
        if(this.model.sov.code == null){
          delete body.sov.code
        }

      }else{
        this.id_edit = param
      }
      this.callApiUpdate(body, isDelete)
    },
    createBrand(){
      let body = {}
      body = {
        name: this.NewBrand,
        industry: this.NewCategories
      }
      this.callApiCreateBrand(body)
    },
    async callApiCreateBrand(body){
      const {data, status} = await api.post(apiV2.sovCreateBrands, body, { 
        needToken: true
      });
      if(status == 201){
        this.isShownModalBrand = !this.isShownModalBrand
        const response = await api.get(apiV2.sovFilter, { needToken: true });
        if (response.status == 200){
          this.BrandListOption = mapListFilter({obj: response.data.brands, id:`id`, value:`id`, label: `name`})
          this.BrandListOption.unshift({id : null, value: 'null', label: '---'})
          this.componentEditKey += 1;

          // reload data brands
          this.listBrand = response.data.brands;
          this.listBrandFull = response.data.brands
          this.listCheckedBrand = []
          this.listCheckedBrand.push(-1)
          this.listBrand.forEach(record => {
            this.listCheckedBrand.push(record.id);
          });
        }
      }
    },
    async callApiUpdate(body, isDelete){
      if(isDelete) this.loadingMap =  false
      const token = store.getters.token
      const {data, status} = await api.put(apiV2.sovUpdate(this.id_edit), body, { 
        needToken: true,
      });
      if(status == 200){
        this.isShownModalEdit = false
        this.isShownModalDeletePlacement = false
        if(isDelete) this.showNotificationAlert('Success', 'Deleted Placement successfully', 'success') 
        this.loadBillboard();
        this.closeWindowBillboard();
        this.loadingMap =  true
      }
    },
    async updateLocation(){
      this.loadingMap =  false
      let body = {
        is_deleted : true
      }
      const {data, status} = await api.put(apiV2.sovEditLocation(this.billboardId), body, { 
        needToken: true,
      });
      if(status == 200){
        this.isShownModalEdit = false
        this.isShownModalDeleteLoc = false
        this.loadBillboard();
        this.closeWindowBillboard();
        this.showNotificationAlert('Success', 'Deleted Location successfully', 'success')
        this.loadingMap =  true
      }
    },
    async uploadPhoto(photo){
      const {data, status} = await api.patch(apiV2.sovImageUpload(this.id_edit), photo, { 
        needToken: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      if(status == 200){
        this.showNotificationAlert('Success', 'Image uploaded successfully', 'success')
      }else{
        this.showNotificationAlert('Error', 'Your image upload has failed', 'danger')
      }
    },
    changeIndustry(value){
      this.CategoriesListOption = mapListFilter({obj: this.IndustryList[value.item.label], value:`id`, label: `name`})
      this.NewIndustry = value.item.label
      this.componentKey += 1;
    },
    changeEmpty(value){
      if (value.item.value == 'null'){
        this.model.is_empty = true  
      }else{
        this.model.is_empty = false
      }
    },
    reload(){
      this.closeWindowBillboard();
      this.loadBillboard();
      this.showNotificationAlert('Success', 'Reloaded successfully', 'success')
    },
    getLabel(){
      return 'File jpg or png, max 50kb'
    },
    toggleModal(side){
      var log = this.placements.log_placement.map(data => data)
      this.listHistory = log.filter(log => log.side == side)
      this.isShowModal = !this.isShowModal
    },
    displayDate(date){
      if(date){
        var dategmt = moment(date);
        return `${lib.formatShortMonthYear(moment(dategmt))}`
      }
    },
    
  },
  computed: {
    filteredCity() {
      return this.listCity.filter((city) => {
        return city.name.toLowerCase().includes(this.searchCity.toLowerCase())
      })
    },
    filteredBrand() {
      return this.listBrand.filter((brand) => {
        return brand.name.toLowerCase().includes(this.searchBrand.toLowerCase())
      })
    },
    filteredRoute() {
      return this.listRoute.filter((route) => {
        return route.name.toLowerCase().includes(this.searchRoute.toLowerCase())
      })
    },
    // isFirstLoad() {
    //   return this.loadDataStreet && this.loadDataCity && this.loadDataBillboard;
    // },
    ...mapGetters({
      token: "token",
      account: "account"
    })
  },
  updated: function () {
    this.$nextTick(function () {
      if (this.modalChanged == this.isShowModal){
        if(this.placements){
          this.initialSlide("section", "block")
          this.initialSlide("empty", "block")
          this.initialSlide("ownerInfo", "block")
          this.initialSlide("photo", "flex")
          this.initialSlide("advertising", "block")
          this.initialSlide("edit_detail", "block")
          if(this.placements.placement.length > 1){
            this.initialSlide("index_number", "block")
          }
      }
      }
    this.modalChanged = this.isShowModal
    })
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>

<style lang="scss">
.gm-style {
  .gm-style-iw-c {
    padding: 0;
  }

  .gm-style-iw-d {
    overflow: hidden !important;
  }
}

.gm-ui-hover-effect {
  opacity: 1 !important;
  background: #fff !important;
  margin: 12px !important;
  border-radius: 18px;
  width: 24px !important;
  height: 24px !important;

  img{
    margin: 5.5px !important;
  }
}

.gm-style .gm-style-cc span, .gm-style .gm-style-cc a, .gm-style .gm-style-mtc div {
    font-size: 13px !important;
    box-sizing: border-box;
}

footer {
    height: 80px;
    display: none !important;
}

.chevron-button{
  cursor: pointer;
}
.window-wrapper1 {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;

  .window-bg1 {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.88);
  }

  .info_window1 {
    position: absolute;
  }
}
</style>
